import Divider from "@ui-kit/data-display/Divider/Divider.web";
import Box from "@ui-kit/layout/Box/Box.web";
import useAssignedSeatingHelpers from "@shared/hooks/seating/useAssignedSeatingHelpers/useAssignedSeatingHelpers";
import { useSeatingState } from "@shared/modules/seating/contexts/useSeatingState";
import { SeatingItemPropertyMap } from "@shared/modules/seating/types/seating-property-types";
import { useTranslation } from "@shared/utils/internationalization";
import { useMemo } from "react";
import ItemBody from "../ItemBody/ItemBody.web";
import ItemHeader from "../ItemHeader/ItemHeader.web";
import { CartSeatItemProps } from "./CartSeatItem.props";

const CartSeatItem = (props: CartSeatItemProps) => {
  const { t } = useTranslation("seating");

  const { removeSeatPermission } = useAssignedSeatingHelpers();
  const { seatingEventData } = useSeatingState();

  const { formattedData, disableItemDeletion, venueData } = props;

  // get the full item type object to display item properties
  const itemObj: SeatingItemPropertyMap = useMemo(() => {
    const itemTypes =
      seatingEventData?.ticket_types ??
      seatingEventData?.tickettype_set ??
      seatingEventData?.membership_levels ??
      [];
    const itemTypesWithMembershipLevels = itemTypes.concat(
      seatingEventData?.membership_ticket_types ?? []
    );
    return itemTypesWithMembershipLevels?.find(
      (item: { id: number }) =>
        item.id === formattedData.itemGroup?.type ||
        item.id === formattedData.itemGroup?.membership_level
    );
  }, [seatingEventData, formattedData]);

  const headerVals = useMemo(
    () => [
      {
        id: 0,
        title: t("Section"),
        value: formattedData.seat?.segment_identifier ?? "",
      },
      {
        id: 1,
        title: t("Row"),
        value: formattedData.seat?.location_identifier ?? "",
      },
      {
        id: 2,
        title: t("Seat"),
        value: formattedData.seat?.identifier ?? "",
      },
    ],
    [t, formattedData]
  );

  return (
    <Box
      m="0px 20px"
      p="xs"
      borderRadius="md"
      backgroundColor="gray.200"
      mb="md"
      key={formattedData.permissionId}
    >
      <ItemHeader
        headerVals={headerVals}
        removeItem={() =>
          removeSeatPermission(Number(formattedData.permissionId), null)
        }
        disableRemoveButton={disableItemDeletion}
      />

      <Divider my="xs" />

      <ItemBody
        formattedData={formattedData}
        itemObj={itemObj}
        venueData={venueData}
        seatingEventName={seatingEventData?.name}
        isLimitedVisibility={formattedData.seat.is_limited_visibility}
        isAccessible={formattedData.seat.is_accessible}
      />
    </Box>
  );
};

export default CartSeatItem;
